import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";

import visiable from "../../assets/visiable.svg";
import "./PublishIndiaPdf.scss";
import PublishIndiaPdfFormDialog from "./PublishIndiaPDFFormDialog";
import { appConfig } from "../../config/appConfig";
import Spinner from "../spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { logout } from "../../services/IndiaService";

import { getStorageItemLocal } from "../../services/storageServices";

type AdminEntry = {
  [x: string]: any;
  id: number;
  pdfName: string;
  pdfUrls: string | string[];
  isActive: boolean;
  status: string;
};

interface count {
  setIndiaPDFCount: any;
  visible: boolean;
}

const PublishIndiaPdf: React.FC<count> = ({ setIndiaPDFCount, visible }) => {
  const [dataList, setDataList] = useState<AdminEntry[]>([]);
  const [filterList, setFilterList] = useState<AdminEntry[]>([]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [showForm, setShowForm] = useState(false);

  const [formData, setFormData] = useState<AdminEntry>({
    id: 0,
    pdfName: "",
    pdfUrls: [],
    isActive: false,
    status: "",
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const savedData = localStorage.getItem("adminDataList");
    if (savedData) {
      const parsedData: AdminEntry[] = JSON.parse(savedData);
      // setDataList(parsedData);
      setFilterList(parsedData);
      if (!savedData || parsedData.length === 0) {
        setEditingIndex(null);
      }
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const filteredData = filterList.filter((item) => item.status === "Pending");
    setDataList(filteredData);
    setIndiaPDFCount(filteredData.length);
  }, [filterList]);
  useEffect(() => {
    if (editingIndex !== null) {
      const selectedEntry = dataList.find((item) => item.id === editingIndex);
      if (selectedEntry) {
        const pdfUrls =
          typeof selectedEntry.pdfUrls === "string"
            ? selectedEntry.pdfUrls.split(",")
            : Array.isArray(selectedEntry.pdfUrls)
            ? selectedEntry.pdfUrls
            : [];
        setFormData({
          ...selectedEntry,
          pdfUrls,
        });
      }
    }
  }, [editingIndex, dataList]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(appConfig.serviceUrls.saveIndiaPDFEntries, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error("Failed to fetch data");
      const data: AdminEntry[] = await response.json();
      // setDataList(data || []);
      setFilterList(data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      id: dataList.length + 1, // Increment ID
      pdfName: "",
      pdfUrls: [],
      isActive: false,
      status: "",
    });
    setEditingIndex(null);
  };

  // handle approve
  const handleApprove = async (index: number) => {
    if (!window.confirm("Are you sure want to approve & publish this entry?"))
      return;
    await handlePublish(index, "Published", "3");
  };
  // handle reject
  const handleReject = async (index: number) => {
    if (!window.confirm("Are you sure want to reject this entry?")) return;
    await handlePublish(index, "Rejected", "2");
  };

  //handle Publish

  const handlePublish = async (
    index: number,
    stat: string,
    statcode: string
  ) => {
    // if (!window.confirm("Are you sure you want to publish this entry?")) return;

    const selectedEntry = dataList[index];
    if (!selectedEntry) {
      alert("Invalid entry selected for publishing.");
      return;
    }
    setLoading(true);
    const formDataToSend = new FormData();
    formDataToSend.append("id", selectedEntry.id.toString());
    // formDataToSend.append("status", "Published");
    formDataToSend.append("pdfName", selectedEntry.pdfName);
    formDataToSend.append("isActive", selectedEntry.isActive.toString());
    formDataToSend.append("uploadBy", selectedEntry.uploadBy);

    const username = getStorageItemLocal("username") ?? "";
    formDataToSend.append("approveBy", username);
    formDataToSend.append("status", stat); // override
    formDataToSend.append("statusCode", statcode);
    // formDataToSend.append("pdfUrls", selectedEntry.pdfUrls.toString());
    formDataToSend.append("pdfUrls", selectedEntry.pdfUrls?.toString() ?? "");

    formDataToSend.append("publishBy", username);

    setLoading(true);

    const url = `${appConfig.serviceUrls.saveIndiaPDFEntries}/${selectedEntry.id}`;
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(url, {
        method: "PUT",
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        logout(navigate);
        <Button onClick={() => logout(navigate)}>Logout</Button>;
        return;
      }
      if (!response.ok) throw new Error("Failed to publish entry");

      alert(`Data ${stat} successfully`);
      fetchData();
      resetForm();
      setEditingIndex(null);
      setShowForm(false);
    } catch (error) {
      console.error("Error publishing entry:", error);
      alert("Network Error.");
    } finally {
      setLoading(false);
    }
  };

  if (!visible) return null;

  return (
    <>
      {loading ? (
        <>
          {" "}
          <Spinner></Spinner>
        </>
      ) : (
        <></>
      )}

      <TableContainer
        component={Paper}
        sx={{
          marginTop: "0.5px",
          width: "100%",
        }}
      >
        {dataList?.length > 0 ? (
          <Table size="small">
            <TableHead>
              <TableRow className="custom-table-head-row">
                <TableCell>
                  <b>Request ID</b>
                </TableCell>
                <TableCell>
                  <b>PDF Name</b>
                </TableCell>

                <TableCell className="nowrap">
                  <b>PDF file</b>
                </TableCell>

                <TableCell className="nowrap">
                  <b>Active / Disable</b>
                </TableCell>
                <TableCell className="nowrap">
                  <b>Status</b>
                </TableCell>

                <TableCell>
                  <b>Actions</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataList
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell className="nowrap">
                      MAP-{item.id || "\u00A0"}
                    </TableCell>
                    <TableCell>{item.pdfName}</TableCell>

                    <TableCell>
                      {typeof item.pdfUrls === "string" &&
                      item.pdfUrls.trim() !== "" ? (
                        <Box className="description-wraper">
                          <Typography className="description-txt">
                            View PDF
                          </Typography>

                          <div key={index}>
                            <a
                              href={item.pdfUrls.trim()}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton color="primary" size="small">
                                <img
                                  src={visiable}
                                  alt="visible"
                                  className="img-style"
                                />
                              </IconButton>
                            </a>
                          </div>
                        </Box>
                      ) : (
                        <Typography>No PDF</Typography>
                      )}
                    </TableCell>

                    <TableCell className="nowrap">
                      <Box className="status-wrapper">
                        <Box
                          className={`status-toggle1 ${
                            item.isActive ? "active" : "Disable"
                          }`}
                        >
                          <Box className="status-circle" />
                        </Box>

                        <Typography className="active-txt" component="span">
                          {item.isActive ? "Active" : "Disable"}
                        </Typography>
                      </Box>
                    </TableCell>
                    {item.status === "Approved" ? (
                      <TableCell className="approved-text">
                        {item.status}
                      </TableCell>
                    ) : item.status === "Published" ? (
                      <TableCell className="publish-txt">
                        {item.status}
                      </TableCell>
                    ) : item.status === "Pending" ? (
                      <TableCell className="pending-txt">
                        {item.status}
                      </TableCell>
                    ) : (
                      <TableCell>{item.status}</TableCell>
                    )}

                    <TableCell align="left" className="nowrap display-btn">
                      <IconButton
                        className="reject-box"
                        size="small"
                        onClick={() => {
                          handleReject(page * rowsPerPage + index);
                        }}
                      >
                        <Typography className="box-text">Reject</Typography>
                      </IconButton>

                      <IconButton
                        className="approve-box"
                        size="small"
                        onClick={() => {
                          handleApprove(page * rowsPerPage + index);
                        }}
                      >
                        <Typography className="box-text">
                          Approve & Publish
                        </Typography>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "1rem",
            }}
          >
            <Typography>No records found.</Typography>
          </Box>
        )}
      </TableContainer>

      <PublishIndiaPdfFormDialog
        open={showForm}
        onClose={() => setShowForm(false)}
        fetchData={fetchData}
        resetForm={resetForm}
        formData={formData}
        setFormData={setFormData}
        editingIndex={editingIndex}
        setShowForm={setShowForm}
        setEditingIndex={setEditingIndex}
        dataList={dataList}
      />
    </>
  );
};

export default PublishIndiaPdf;
